import React, { useEffect, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useContent } from '../../content/ContentContext';
import { useLang } from '../../i18n/LanguageContext';
import { useUi } from '../../i18n/ui';

const LINKS = [
  { to: '/', key: 'nav.home', end: true },
  { to: '/storia', key: 'nav.storia' },
  { to: '/tour', key: 'nav.tour' },
  { to: '/gare', key: 'nav.gare' },
  { to: '/iscrizioni', key: 'nav.iscrizioni' },
  { to: '/contatti', key: 'nav.contatti' },
];

const LOGO = '/img/INSOLITA_SARDEGNA_LOGO_MOTOCLUB-white.svg';

const LangSwitch: React.FC = () => {
  const { lang, setLang } = useLang();
  return (
    <div className="lang-switch" role="group" aria-label="Lingua / Language">
      <button type="button" className={lang === 'it' ? 'on' : ''} aria-pressed={lang === 'it'} onClick={() => setLang('it')}>IT</button>
      <button type="button" className={lang === 'en' ? 'on' : ''} aria-pressed={lang === 'en'} onClick={() => setLang('en')}>EN</button>
    </div>
  );
};

const Nav: React.FC<{ transparent?: boolean }> = ({ transparent = false }) => {
  const [scrolled, setScrolled] = useState(!transparent);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { t, img } = useContent();
  const { tr } = useUi();
  const navigate = useNavigate();
  const phone = t('contact.phone', '+393467814537');
  const logo = img('brand.logo', LOGO);

  useEffect(() => {
    const onScroll = () => setScrolled(transparent ? window.scrollY > 40 : true);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [transparent]);

  useEffect(() => {
    document.body.style.overflow = drawerOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [drawerOpen]);

  const goBook = () => {
    setDrawerOpen(false);
    navigate('/tour#prenota');
  };

  return (
    <>
      <header className={`nav${scrolled ? ' scrolled' : ''}`}>
        <Link to="/" className="nav__logo"><img src={logo} alt="Insolita Sardegna" /></Link>
        <nav className="nav__links">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end}
              className={({ isActive }) => (isActive ? 'active' : '')}>
              {tr(l.key)}
            </NavLink>
          ))}
        </nav>
        <div className="nav__cta">
          <LangSwitch />
          <a href={`tel:${phone}`} className="btn btn-ghost hide-sm">{formatPhone(phone)}</a>
          <button className="btn btn-acid" onClick={goBook}>{tr('nav.book')}</button>
          <button className="nav__burger" aria-label="Menu" onClick={() => setDrawerOpen((o) => !o)}>
            <span></span><span></span><span></span>
          </button>
        </div>
      </header>

      <div className={`drawer${drawerOpen ? ' open' : ''}`}>
        {LINKS.map((l) => (
          <NavLink key={l.to} to={l.to} end={l.end} onClick={() => setDrawerOpen(false)}>
            {tr(l.key)}
          </NavLink>
        ))}
        <div style={{ marginTop: 18 }}><LangSwitch /></div>
        <div className="foot">Olbia — Sardegna<br />{t('contact.email', 'info@insolitasardegna.com')}</div>
      </div>
    </>
  );
};

function formatPhone(p: string): string {
  const digits = p.replace(/[^0-9]/g, '').replace(/^39/, '');
  if (digits.length === 10) return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
  return p;
}

export default Nav;
